import { subMilliseconds, parseISO } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { TIMEZONE_NUMBER_DEFINITION } from '@app/constants/stats'

const addDataPlaceholder = (startDate, timezone) => {
  const tz = timezone.slice(TIMEZONE_NUMBER_DEFINITION)
  const zoned = utcToZonedTime(typeof startDate === 'string' ? parseISO(startDate) : startDate, tz)
  const start1 = subMilliseconds(zoned, 2)
  const start2 = subMilliseconds(zoned, 1)
  const row = (label) => [
    I18n.t(`stats.${label}`),
    '',
    'opacity: 0',
    '',
    start1,
    start2,
  ]
  return [
    row('tcp_ethernet'),
    row('udp_ethernet'),
    row('offline'),
    row('tcp_gsm'),
    row('udp_gsm'),
  ]
}

export default addDataPlaceholder
